import { Flex, Text } from "@chakra-ui/react"
import { formatPrice } from "../../../../../utils/formatPrice"

// const taxas = {
//   "fretepeso": "76.65",
//   "gris": "27.75",
//   "tde": "49.43",
//   "agendamentodeentrega": "40.93"
// };

export function Taxas({ taxas }) {
  if (!taxas) return (
    <Flex w="100%" justifyContent="space-between">
      <Text>Não há taxas</Text>
    </Flex>
  )

  const taxasEntries = Object.entries(taxas) // [['taxa1', 10], ['taxa2', 20]]
  
  return (
    taxasEntries.map(([taxa, valor]) => (
      <Flex w="100%" justifyContent="space-between">
        <Text>{taxa}</Text>
        <Text>{formatPrice(valor)}</Text>
      </Flex>
    ))
  )
}